(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["il-brand-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('il-brand-directory')) {
    class IlBrandDirectory extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-brand-search]');
        if (!this.input) return;

        this.querySelector('[data-brand-search-wrap]').hidden = false;
        this.items = [...this.querySelectorAll('[data-brand]')].map((li) => ({ li, name: li.dataset.brand.toLowerCase() }));
        this.groups = [...this.querySelectorAll('[data-brand-group]')];
        this.letters = [...this.querySelectorAll('[data-brand-letter]')];
        this.status = this.querySelector('[data-brand-status]');
        this.onInput = this.filter.bind(this);
        this.input.addEventListener('input', this.onInput);
      }

      disconnectedCallback() {
        this.input?.removeEventListener('input', this.onInput);
      }

      filter() {
        const query = this.input.value.trim();
        const q = query.toLowerCase();
        let shown = 0;

        for (const item of this.items) {
          const hit = !q || item.name.includes(q);
          item.li.hidden = !hit;
          if (hit) shown += 1;
        }

        const live = new Set();
        for (const group of this.groups) {
          const any = group.querySelector('[data-brand]:not([hidden])') !== null;
          group.hidden = !any;
          if (any) live.add(group.dataset.brandGroup);
        }

        for (const link of this.letters) {
          const on = live.has(link.dataset.brandLetter);
          link.classList.toggle('is-off', !on);
          if (on) {
            link.removeAttribute('aria-disabled');
            link.removeAttribute('tabindex');
          } else {
            link.setAttribute('aria-disabled', 'true');
            link.setAttribute('tabindex', '-1');
          }
        }

        this.status.textContent = shown === 0 ? this.status.dataset.template.replace('[query]', query) : '';
      }
    }

    customElements.define('il-brand-directory', IlBrandDirectory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["il-deadline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('il-deadline')) {
    class IlDeadline extends HTMLElement {
      connectedCallback() {
        const ends = Date.parse(this.dataset.ends);
        if (Number.isNaN(ends)) return;
        const wait = ends - Date.now();
        if (wait <= 0) return this.cutOff();
        if (wait < 2147483647) this.timer = setTimeout(() => this.cutOff(), wait);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      cutOff() {
        const before = this.querySelector('[data-il-state="before"]');
        const after = this.querySelector('[data-il-state="after"]');
        if (before) before.remove();
        if (after) after.hidden = false;
        else this.closest('.shopify-section').remove();
      }
    }
    customElements.define('il-deadline', IlDeadline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["il-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('il-film')) {
    /* Talks to the Vimeo player over its postMessage API, so no extra script is loaded.
       Vimeo reports progress as "playProgress" (its older name for timeupdate). Both are handled. */
    class IlFilm extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('.il-film__frame');
        this.ctrl = this.querySelector('[data-il-film-ctrl]');
        this.pause = this.querySelector('[data-il-film-pause]');
        this.sound = this.querySelector('[data-il-film-sound]');
        this.start = this.querySelector('[data-il-film-start]');
        this.prog = this.querySelector('[data-il-film-prog]');
        this.onMessage = this.onMessage.bind(this);
        window.addEventListener('message', this.onMessage);

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduce) {
          this.mount(this.dataset.auto, false);
          this.ctrl.hidden = false;
          if (this.prog) this.prog.hidden = false;
        } else {
          this.start.hidden = false;
        }

        this.start.addEventListener('click', () => this.playWithControls());
        this.pause.addEventListener('click', () => this.togglePause());
        if (this.sound) this.sound.addEventListener('click', () => this.toggleSound());
      }

      disconnectedCallback() {
        window.removeEventListener('message', this.onMessage);
      }

      mount(src, focusable) {
        if (this.iframe) this.iframe.remove();
        const f = document.createElement('iframe');
        f.className = 'il-film__iframe' + (focusable ? ' il-film__iframe--player' : '');
        f.src = src;
        f.title = this.dataset.title;
        f.allow = 'autoplay; fullscreen; picture-in-picture';
        f.referrerPolicy = 'strict-origin-when-cross-origin';
        if (focusable) {
          f.setAttribute('allowfullscreen', '');
        } else {
          f.tabIndex = -1;
          f.setAttribute('aria-hidden', 'true');
        }
        this.frame.appendChild(f);
        this.iframe = f;
        return f;
      }

      send(method, value) {
        if (!this.iframe) return;
        const msg = value === undefined ? { method } : { method, value };
        this.iframe.contentWindow.postMessage(JSON.stringify(msg), 'https://player.vimeo.com');
      }

      onMessage(event) {
        if (!this.iframe || event.source !== this.iframe.contentWindow || event.origin !== 'https://player.vimeo.com') return;
        let data;
        try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch (e) { return; }
        if (!data) return;
        if (data.event === 'ready') this.send('addEventListener', 'playProgress');
        if ((data.event === 'playProgress' || data.event === 'timeupdate') && data.data && this.prog) {
          this.prog.firstElementChild.style.width = (data.data.percent * 100).toFixed(2) + '%';
        }
      }

      togglePause() {
        const paused = this.pause.getAttribute('aria-pressed') === 'true';
        this.send(paused ? 'play' : 'pause');
        this.pause.setAttribute('aria-pressed', String(!paused));
        this.querySelector('[data-il-film-pause-label]').textContent = paused ? this.dataset.labelPause : this.dataset.labelPlay;
      }

      toggleSound() {
        const on = this.sound.getAttribute('aria-pressed') !== 'true';
        this.send('setMuted', !on);
        this.send('setVolume', on ? 1 : 0);
        if (on && this.pause.getAttribute('aria-pressed') === 'true') this.togglePause();
        this.sound.setAttribute('aria-pressed', String(on));
        this.querySelector('[data-il-film-sound-label]').textContent = on ? this.dataset.labelSoundOn : this.dataset.labelSoundOff;
      }

      /* Reduced motion, or autoplay switched off: Vimeo's own player, with its own controls. */
      playWithControls() {
        this.start.remove();
        const poster = this.querySelector('.il-film__poster');
        if (poster) poster.remove();
        this.ctrl.hidden = true;
        if (this.prog) this.prog.hidden = true;
        this.mount(this.dataset.sound, true).focus();
      }
    }
    customElements.define('il-film', IlFilm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["il-gift-tags"] && !Shopify.designMode) return;
  try {
    
  /**
   * IL | Gift tags: sways each tag once as it comes into view. Without this
   * the tags simply hang at their tilt, so nothing depends on it.
   */
  class IlGiftTags extends HTMLElement {
    #observer = null;

    connectedCallback() {
      if (!this.hasAttribute('data-sway')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      this.#observer = new IntersectionObserver(this.#onIntersect.bind(this), { threshold: 0.5 });
      for (const tag of this.querySelectorAll('.il-gift-tags__tag')) {
        this.#observer.observe(tag);
      }
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    /** @param {IntersectionObserverEntry[]} entries */
    #onIntersect(entries) {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const tag = entry.target;
        this.#observer.unobserve(tag);
        // The animation fills both ways, so it is removed when done or it would hold the hover swing.
        tag.addEventListener('animationend', () => tag.classList.remove('is-swaying'), { once: true });
        tag.classList.add('is-swaying');
      }
    }
  }

  if (!customElements.get('il-gift-tags')) {
    customElements.define('il-gift-tags', IlGiftTags);
  }

  } catch(e) { console.error(e); }
})();
})();
